import {type FluTarget,type FluScreen,fluScreens,fluTargets,targetsForScreen} from '../../../../supabase/functions/_shared/fluScreenContext';
const selectors:Record<FluTarget,string>={'lead-pipeline':'button[data-flu-target="lead-pipeline"]','settings-users':'button[data-flu-target="settings-users"]','settings-lead-pipelines':'button[data-flu-target="settings-lead-pipelines"]','header-search':'button[aria-label="Cerca"]','header-notifications':'button[aria-label="Notifiche"]'};
export function resolveFluTarget(id:FluTarget):HTMLButtonElement|null{
 if(!Object.hasOwn(selectors,id))return null;
 const visible=Array.from(document.querySelectorAll<HTMLButtonElement>(selectors[id])).filter(el=>{
  const r=el.getBoundingClientRect(),s=getComputedStyle(el);
  return !el.disabled&&!el.closest('[hidden],[inert],[aria-hidden="true"]')&&s.visibility!=='hidden'&&s.display!=='none'&&r.width>0&&r.height>0&&r.bottom>0&&r.right>0&&r.top<window.innerHeight&&r.left<window.innerWidth;
 });
 return visible.length===1?visible[0]:null;
}
export function availableFluTargets(screen:string){return targetsForScreen(screen).filter(id=>!!resolveFluTarget(id));}
/** Only the user's Open button reaches this fixed list of read-only controls. */
export function openFluTarget(id:FluTarget){
 if(!Object.hasOwn(fluTargets,id)||!fluTargets[id].openLabel)return false;
 const target=resolveFluTarget(id);if(!target)return false;target.click();return true;
}

/** Settings changes tabs via history.replaceState, so the rendered panel declares its static identity. */
export function readFluView(fallback:FluScreen):{screen:FluScreen;viewMarker:string}{
 if(!fallback.startsWith('settings'))return {screen:fallback,viewMarker:''};
 const roots=Array.from(document.querySelectorAll<HTMLElement>('[data-flu-screen]')).filter(el=>{
  const r=el.getBoundingClientRect();return !el.closest('[hidden],[inert],[aria-hidden="true"]')&&r.width>0&&r.height>0&&getComputedStyle(el).display!=='none';
 });
 if(roots.length!==1)return {screen:fallback,viewMarker:''};
 const screen=roots[0].getAttribute('data-flu-screen'),view=roots[0].getAttribute('data-flu-view');
 if(!fluScreens.includes(screen as FluScreen)||!screen?.startsWith('settings'))return {screen:fallback,viewMarker:''};
 return {screen:screen as FluScreen,viewMarker:view&&/^[a-z0-9-]{1,80}$/.test(view)?view:''};
}
